import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TcNav from "./TcNav";
import "../../styles/tcDash.css";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
export default function UpdateCase() {
  const navigate = useNavigate();

  useEffect(() => {
    getLaw();
  }, []);

  const [formData, setFormData] = useState({
    violations: "",
    fine: "",
  });

  const params = useParams();

  const getLaw = async () => {
    try {
      let response = await fetch(`http://localhost:8000/laws/${params.key}`);
      response = await response.json();
      // Check if the response is an array
      const caseData = Array.isArray(response) ? response[0] : response;

      setFormData(caseData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.warn(typeof formData);
    let result = await fetch(`http://localhost:8000/laws/${params.key}`, {
      method: "Put",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "Application/json",
      },
    });
    result = await result.json();

    if (result) {
      toast.success("Law Updated", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });

      
    }
  };

  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main>
        <div className="container mt-4 mb-4 d-flex  flex-column justify-content-center align-items-center">
          <div class=" input-group .bg-light-subtle w-50  mb-3 searches">
            <input
              type="text"
              className="form-control"
              placeholder="Input Violation Rule"
              name="violations"
              value={formData.violations}
              onChange={handleChange}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Input Fine"
              name="fine"
              value={formData.fine}
              onChange={handleChange}
            />
            <button
              onClick={handleSubmit}
              type="submit"
              className="btn btn-outline-light"
            >
              Update Law
            </button>
          </div>
        </div>
      </main><ToastContainer/>
    </div>
  );
}
